import { object, shape } from 'prop-types';
import UserPropType from '../../proptypes/UserPropType';

export const userConnectionPropTypes = shape({
  user: UserPropType,
  actions: object
});
